import React, { useRef } from "react";
import { EmbedThumbProps } from "./EmbedThumb.types";
import ReactHtmlParser from 'react-html-parser';
import { EmbedThumbContainer } from "./EmbedThumb.style";


const EmbedThumb: React.FC<EmbedThumbProps> = ({ html, embedImageReference, alt}) => {
  const [isPlaying, setIsPlaying] = React.useState(false);



  const handlePlay = () => {
    setIsPlaying(true);
  };

  return (
    <EmbedThumbContainer className="embedThumb">
      <div className="embed-container">
        <div className="embed-style" >
          {!isPlaying ? (
              <div className="embed-image">
                  <img onClick={handlePlay}
                    src={embedImageReference}
                    alt={alt}
                  />
              </div>
          ) : (
            <div>{ReactHtmlParser(html)}</div>
          )}
      </div>
      </div>
    </EmbedThumbContainer>
);
};

export default EmbedThumb;


